<template>
  <v-dialog max-width="600" persistent v-model="value">
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ deleteText }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onClickCancel">Cancel</v-btn>
        <v-btn text color="red" @click="onClickDelete">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    deleteText: {
      type: String,
      default: () => "Do you really want to delete this item?"
    },
    item: [Object, Array],
    title: {
      type: String,
      default: () => "Delete"
    }
  },
  methods: {
    onClickCancel() {
      this.$emit("cancel", this.item);
      this.$emit("input", false);
    },
    onClickDelete() {
      this.$emit("delete", this.item);
      this.$emit("input", false);
    }
  }
};
</script>

<style scoped></style>
